import WorkerStat from './WorkerStat';

export default WorkerStat;
